import {isNonNegativeDecimal} from './isNonNegativeDecimal';

const DECIMAL_SEPARATOR = '.';

/**
 * The currency scale is the number of digits after `.` in a published amount ("24000.00" is 2,
 * "1000000" is 0), because the backend serialises Money at its currency's scale. Neither
 * `Decimal#decimalPlaces()` ("24000.00" would be 0) nor `Intl` (HUF and ALL disagree with the
 * backend's ISO scale) gives the same answer. Null when the amount is not a non-negative decimal.
 */
export function getCurrencyScale(amount: string): number | null {
  if (!isNonNegativeDecimal(amount)) {
    return null;
  }

  const separatorIndex = amount.indexOf(DECIMAL_SEPARATOR);

  return separatorIndex === -1 ? 0 : amount.length - separatorIndex - 1;
}
